module.exports = __webpack_public_path__ + "static/media/logo-leitner-ropeways-landscape.fe4573a3.svg";